<template>
  <div class="talent-development">
    <div class="banner">
      <img src="../../assets/img/talentDevelopment/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("talentDevelopment.banner.bannerTitle")}}</h1>
          <p>{{$t("talentDevelopment.banner.bannerP")}}</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="growthAnd-development" >
        <div class="headline">
          <h1>{{$t("talentDevelopment.growthAndDevelopment.headlineTitle")}}</h1>
          <p>{{$t("talentDevelopment.growthAndDevelopment.headlineP")}}</p>
        </div>
        <div v-html="$t('talentDevelopment.growthAndDevelopment.des')" class="des"></div>
        <el-row :gutter="100">
          <el-col :span="12" :xs="24" >           
            <h2>{{ $t("talentDevelopment.growthAndDevelopment.boxRow.title") }}</h2>
            <p>{{ $t("talentDevelopment.growthAndDevelopment.boxRow.p") }}</p>
          </el-col>
          <el-col :span="12"  :xs="24">
            <div class="pic">
              <img src="../../assets/img/talentDevelopment/fazhan1.jpg" />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="12" :xs="24" >
            <div class="pic">
              <img src="../../assets/img/talentDevelopment/fazhan2.jpg" />
            </div>
          </el-col>
          <el-col :span="12" :xs="24" >           
            <h2>{{ $t("talentDevelopment.growthAndDevelopment.boxRow2.title") }}</h2>
            <p>{{ $t("talentDevelopment.growthAndDevelopment.boxRow2.p") }}</p>
          </el-col>
        </el-row>
      </div>
      <div class="employee-care" >
        <div class="headline">
          <h1>{{$t("talentDevelopment.employeeCare.headlineTitle")}}</h1>
          <p>{{$t("talentDevelopment.employeeCare.headlineP")}}</p>
        </div>
        <p class="des">{{$t('talentDevelopment.employeeCare.des')}}</p>

        <swiper :options="employeeOption" class="employeeOption" v-if="employeeLists.length" >
          <swiper-slide class="swiper-slide" v-for="(item,index) in employeeLists" :key="index"  >
            <img :src="item.picturePath" alt=""/>
            <div class="des-box">
              <!-- <p>{{item.createTime.slice(0,10)}}</p> -->
              <!-- <p>{{item.picName}}</p> -->
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="talent-recruitment" >
        <div class="headline">
          <h1>{{$t("talentDevelopment.talentRecruitment.headlineTitle")}}</h1>
          <p>{{$t("talentDevelopment.talentRecruitment.headlineP")}}</p>
        </div>
        <p class="des">{{$t('talentDevelopment.talentRecruitment.des')}}</p>
        <div class="talent-content">
          <el-row :gutter="60">
            <el-col :span="12" >
              <div>
                <h1>01</h1>
                <p class="title">{{ $t("talentDevelopment.talentRecruitment.part1") }}</p>
                <p class="join-btn"><router-link to="/talentRecruitment/1">{{ $t("talentDevelopment.talentRecruitment.join") }}</router-link></p>
              </div>
            </el-col>
            <el-col :span="12"  > 
              <div>
                <h1>02</h1>
                <p class="title">{{ $t("talentDevelopment.talentRecruitment.part2") }}</p>
                <p class="join-btn"><router-link to="/talentRecruitment/2">{{ $t("talentDevelopment.talentRecruitment.join") }}</router-link></p>
              </div>          
            </el-col>
          </el-row>
        </div>
        
      </div>
    </div>

  </div>
</template>

<script>
import {getpiclist} from "../../api/about"
import { mapGetters } from "vuex";
export default {
  name: "TalentDevelopment",
  data() {
    return {
      employeeLists:[],
      employeeOption:{
        observer: true,  //开启动态检查器，监测swiper和slide
        observeParents: true,  //监测Swiper 的祖/父元素
        speed: 1000,//切换速度
        // loop:true,//循环
        slidesPerView:4,//显示数量
        spaceBetween:20,//间隔
        freeMode:true,//自动贴合
        autoplay: {//自动播放
          delay: 2000,//自动切换的时间间隔
          stopOnLastSlide: false,//切换到最后一个slide时停止自动切换
          disableOnInteraction: false,//用户操作后是否停止
        },
        breakpoints: { 
          768: {  //当屏幕宽度大于等于320
            slidesPerView: 1,
          },
        }

      },
    };
  },
  computed:{
    ...mapGetters(['language'])
  },
  mounted() {
    
    var options = { live: false };
    new this.$wow.WOW(options).init();
    // 3团队风采 2公司奖章 1员工关爱
    getpiclist(this.language,"1").then(res=>{
      this.employeeLists = res.data[0].picList;
    });
  },
  methods: {
    toAlbum(){
      this.$router.push({path:'/photoAlbum'})
    }
  }
};
</script>

<style scoped lang="scss">
$cblue: #0054A7;
.talent-development{
  .headline {
    padding: 150px 0 60px;
  }
  .growthAnd-development {
    .des{
      width:46%;
      margin:0 auto;
      text-align: justify;
    }
    .el-row{
      margin-top:80px;
      h2{
        margin-top:20%;
        &::after{
          content: "";
          display: block;
          width:54px;
          height: 6px;
          background:$cblue;
          margin:20px 0;
        }
      }
    }
  }
  .employee-care{
    .des{
      width:600px;
      margin:0 auto;
      text-align: center;
      
    }
    .employeeOption{
      margin-top:80px;
      img{
        height:260px;
        width:100%;
        object-fit: contain;
        border-radius: 5px;
      }
      .des-box{
        padding-top:20px;
        p{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:nth-child(1){
            color:#666;
          }
        }
      }
    }
  }
  .talent-recruitment{
    .des{
      width:600px;
      margin:0 auto;
      text-align: center;
    }
    .talent-content{
      width:80%;
      margin:0 auto;
      font-weight: bold;
      margin-top:100px;
      h1{
        font-size: 60px;
      }
      .title{
        font-size: 30px;
      }
      .join-btn {
        border-bottom:1px solid #CBCBCB;
        padding-bottom:20px;
        a{
          color:$cblue;
          cursor: pointer;
        }
      }
    }
  }
  @media screen and (max-width:768px){
    .headline {
      padding: 40px 0 20px;
    }
    .growthAnd-development {
      .des{
        width:100%;
      }
      .el-row{
        margin-top:40px;
        h2{
          font-size: 22px;
          margin-top:0;
        }
      }
    }
    .employee-care{
      .des{
        width:100%;  
      }
      .employeeOption{
        margin-top:40px;
        img{
          height:auto;
          width:100%;
          object-fit: contain;
          border-radius: 5px;
        }
        .des-box{
          padding-top:20px;
          p{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:nth-child(1){
              color:#666;
            }
          }
        }
      }
    }
    .talent-recruitment{
      .des{
        width:100%;
        margin:0 auto;
        text-align: center;
      }
      .talent-content{
        width:100%;
        margin:0 auto;
        font-weight: bold;
        margin-top:40px;
        h1{
          font-size: 28px;
        }
        .title{
          font-size: 18px;
        }
      }
    }
  }
}

</style>
